import { render } from "./DependenciaReq.vue?vue&type=template&id=31d55e4a&scoped=true"
import script from "./DependenciaReq.vue?vue&type=script&lang=js"
export * from "./DependenciaReq.vue?vue&type=script&lang=js"

import "./DependenciaReq.vue?vue&type=style&index=0&id=31d55e4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d55e4a"]])

export default __exports__